var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "d-none d-lg-block"
  }, [_c('v-row', {
    staticClass: "ma-n4",
    attrs: {
      "justify": "center",
      "align": "baseline"
    }
  }, [_vm._l(_vm.tabs, function (tab, index) {
    var _vm$TABS$tab;
    return [_c('v-col', {
      key: `${tab}-text`,
      staticClass: "d-flex align-center pa-4",
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-btn', _vm._g(_vm._b({
      staticClass: "px-16 py-8",
      attrs: {
        "text": ""
      }
    }, 'v-btn', {
      style: {
        opacity: tab == _vm.value ? 1 : 0.3,
        pointerEvents: 'none'
      }
    }, false), {
      click() {
        // $emit('input', tab);
      }
    }), [_c('v-avatar', {
      attrs: {
        "color": "grey lighten-4"
      }
    }, [_c('span', {
      staticClass: "page-text--sm"
    }, [_vm._v(" " + _vm._s(index + 1) + " ")])]), _c('span', {
      staticClass: "ml-8"
    }, [_vm._v(" " + _vm._s((_vm$TABS$tab = _vm.TABS[tab]) === null || _vm$TABS$tab === void 0 ? void 0 : _vm$TABS$tab.text) + " ")])], 1)], 1), index < _vm.tabs.length - 1 ? _c('v-col', {
      key: `${tab}-next`,
      staticClass: "pa-4",
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-icon', _vm._b({}, 'v-icon', {
      style: {
        opacity: 0.3
      }
    }, false), [_vm._v(" mdi-chevron-right ")])], 1) : _vm._e()];
  })], 2)], 1), _c('div', {
    staticClass: "d-block d-lg-none"
  }, [_c('v-card-title', {
    staticClass: "pa-0 justify-center align-center",
    staticStyle: {
      "gap": "8px"
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.tabs.findIndex(function (item) {
    return item == _vm.tab;
  }) + 1) + ". ")]), _c('span', [_vm._v(" " + _vm._s(_vm.TABS[_vm.tab].text) + " ")])])], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }